/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import React, {useEffect} from 'react';
import {BrowserRouter, useLocation} from "react-router";

import {ControlVariant, getSetting, ThemeProvider, voidFunction} from '@dvrd/dvr-controls';

import './util/startup';
import {AppRoutes} from "./routes";
import PopupController from "./components/misc/popupController";
import HeaderController from "./components/header/headerController";
import {BASE_COLOR, CONTRAST_COLOR} from "./util/constants";
import Footer from "./components/footer/footer";

const theme = {
    baseColor: BASE_COLOR,
    contrastColor: CONTRAST_COLOR,
    onChange: voidFunction,
    controlVariant: ControlVariant.SIMPLE,
};

function Page() {
    const location = useLocation();

    useEffect(() => {
        document.documentElement.scrollTo({top: 0, behavior: 'smooth'});
    }, [location]);

    return (
        <div className='page'>
            <AppRoutes/>
        </div>
    )
}

export default function App() {
    useEffect(() => {
        window.setTimeout(() => document.dispatchEvent(new Event('custom-render-trigger')));
    }, []);

    return (
        <BrowserRouter basename={getSetting('appBaseUrl')}>
            <ThemeProvider theme={theme}>
                <PopupController/>
                <HeaderController/>
                <Page/>
                <Footer/>
            </ThemeProvider>
        </BrowserRouter>
    )
}